import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ADDRESS_NORMALIZER,
  ConverterService,
  GlobalMessageService,
  GlobalMessageType,
  Occ,
  OccEndpointsService,
  UserIdService
} from '@spartacus/core'
import { map, switchMap, take, tap } from 'rxjs/operators'
import { MbMyAddressesAdapter } from '../../shared/adapters/mb-my-addresses.adapter'
import { EMPTY } from 'rxjs'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root',
})
export class MbOccMyaccountAddressbookAdapter implements MbMyAddressesAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService,
              protected userIdService: UserIdService,
              protected activeCartService: ActiveCartService,
              protected globalMessageService: GlobalMessageService) {
  }

  load (endpoint: string) {
    return this.userIdService.getUserId().pipe(
      take(1),
      tap(userId => !userId && this.globalMessageService.add({ key: 'address.userError' }, GlobalMessageType.MSG_TYPE_ERROR)),
      switchMap(userId => userId && this.http.get<Occ.AddressList>(this.getEndpoint(endpoint, userId)) || EMPTY),
      map(addressList => addressList.addresses || []),
      this.converter.pipeableMany(ADDRESS_NORMALIZER)
    )
  }

  protected getEndpoint (endpoint: string, userId: string) {
    return this.occEndpoints.buildUrl(
      endpoint,
      {
        urlParams: { userId: userId }
      }
    )
  }
}
